export default __webpack_public_path__ + "static/media/convert-ecredit-to-epoint-step4.4253e3b4.png";